// WebApp changes: Rectangular option boxes with internal checkboxes and responsive spacing
// Reason: Replaces rounded pills with rectangular checkbox options and removes the shield icon for a cleaner, responsive inline layout
import React from "react";
import "./IPChangeDetectionSection.css";

const IPChangeDetectionSection = ({
  isSettingEnabled = false,
  isEnabled = false,
  onToggleEnabled,
  options = { banReader: false, reAuthenticateReader: false, notifySender: false },
  onOptionToggle,
  securityLevel = 1,
  selectedLanguage,
}) => {
  const isL1 = securityLevel === 1;

  const isBanChecked = !isL1 && Boolean(options.banReader);
  const isReAuthChecked = !isL1 && Boolean(options.reAuthenticateReader);
  const isNotifyChecked = Boolean(options.notifySender);

  const isSectionActive = isSettingEnabled && isEnabled;
  const isBanDisabled = !isSectionActive || isL1 || isReAuthChecked;
  const isReAuthDisabled = !isSectionActive || isL1 || isBanChecked;
  const isNotifyDisabled = !isSectionActive;

  const titleText = selectedLanguage?.LstLanguageCodes?.UI_IPChangeDetection || "IP Change Detection";
  const tooltipText = "Mid-session reader IP shift detection & enforcement";
  const banReaderText = selectedLanguage?.LstLanguageCodes?.UI_BanReader || "Ban Reader";
  const reauthReaderText = selectedLanguage?.LstLanguageCodes?.UI_ReAuthenticateReader || "ReAuthenticate Reader";
  const notifySenderText = selectedLanguage?.LstLanguageCodes?.UI_NotifySender || "Notify Sender";

  return (
    <div className={`ip-detection-inline-container ${!isSettingEnabled ? "ip-detection-inactive" : ""}`}>
      {/* Main Checkbox: IP Change Protection (no icon, normal font) */}
      <div className="ip-main-checkbox-wrapper" title={tooltipText}>
        <label className={`ip-main-label ${!isSettingEnabled ? "disabled" : ""}`}>
          <input type="checkbox" className="ip-checkbox-input" checked={isSettingEnabled && isEnabled} disabled={!isSettingEnabled} onChange={(e) => onToggleEnabled && onToggleEnabled(e.target.checked)} />
          <span className="ip-main-title">{titleText}</span>
        </label>
      </div>

      {/* Options Row: Rectangular boxes with checkboxes inside */}
      <div className={`ip-options-inline-row ${!isSectionActive ? "options-disabled" : ""}`}>
        {/* 1. Ban Reader */}
        <label className={`ip-option-box box-ban ${isBanChecked ? "selected" : ""} ${isBanDisabled ? "disabled" : ""}`}
          title={isL1 ? "Not available for Protect Views (L1)" : isReAuthChecked ? "Cannot be selected when ReAuthenticate Reader is active" : banReaderText}>
          <input type="checkbox" className="ip-option-checkbox" checked={isBanChecked} disabled={isBanDisabled} onChange={() => onOptionToggle && onOptionToggle("banReader")} />
          <span className="ip-option-text">{banReaderText}</span>
        </label>

        {/* 2. ReAuthenticate Reader */}
        <label
          className={`ip-option-box box-reauth ${isReAuthChecked ? "selected" : ""} ${isReAuthDisabled ? "disabled" : ""}`}
          title={isL1 ? "Not available for Protect Views (L1)" : isBanChecked ? "Cannot be selected when Ban Reader is active" : reauthReaderText}>
          <input type="checkbox" className="ip-option-checkbox" checked={isReAuthChecked} disabled={isReAuthDisabled} onChange={() => onOptionToggle && onOptionToggle("reAuthenticateReader")} />
          <span className="ip-option-text">{reauthReaderText}</span>
        </label>

        {/* 3. Notify Sender */}
        <label className={`ip-option-box box-notify ${isNotifyChecked ? "selected" : ""} ${isNotifyDisabled ? "disabled" : ""}`} title={notifySenderText}>
          <input type="checkbox" className="ip-option-checkbox" checked={isNotifyChecked} disabled={isNotifyDisabled} onChange={() => onOptionToggle && onOptionToggle("notifySender")} />
          <span className="ip-option-text">{notifySenderText}</span>
        </label>
      </div>
    </div>
  );
};

export default IPChangeDetectionSection;